import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable()
export class i18nService {
  private selectedLanguage: string;
  private browserLanguage: string;
  private languageList: string[] = ['es'];

  constructor(public translate: TranslateService) {
    translate.addLangs(this.languageList);
    // this.browserLanguage = translate.getBrowserLang();
    // this.selectedLanguage = translate.getBrowserLang();
    this.browserLanguage = 'es';
    this.selectedLanguage = 'es';
    translate.use('es');
  }

  setLanguageList(languages: string[]) {
    _.extend(this.languageList, languages);
    this.translate.addLangs(this.languageList);
  }

  setLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
  }

  getSelectedLanguage() {
    return this.selectedLanguage;
  }

  setDefaultLang(lang: string) {
    this.translate.setDefaultLang(lang);
  }

  getLanguageList() {
    return this.languageList;
  }

  getLiteral(code: string, params?: any): Promise<any> {
    return new Promise<Object>((resolve, reject) => {
      if (params) {
        this.translate.get(code, params).subscribe((response: Object) => {
          resolve(response);
        });
      } else {
        this.translate.get(code).subscribe((response: Object) => {
          resolve(response);
        });
      }
    });
  }
}
